import { AccountSubtype } from "@common/constants/domains/accounting/accounts";
import {
    TransactionColumn,
    TransactionView,
} from "@common/types/views/transactionViews";
import { NamedView, ViewType } from "@common/types/views/views";

export const TRANSFER_REVIEW_ACCOUNT_SUBTYPES: AccountSubtype[] = [
    AccountSubtype.transferClearing,
    AccountSubtype.creditCardClearing,
    AccountSubtype.contributions,
    AccountSubtype.distributions,
];

export const TRANSFER_REVIEW_VIEW_ID = "transfer-review";

const TRANSFER_REVIEW_BASE = {
    id: TRANSFER_REVIEW_VIEW_ID,
    name: "Match review",
    type: ViewType.TRANSACTION,
    options: {
        bulkActions: true,
        selection: true,
    },
} satisfies Pick<
    NamedView<TransactionView>,
    "id" | "name" | "type" | "options"
>;

function transferReviewColumns(
    middleColumns: TransactionView["columns"],
): TransactionView["columns"] {
    return [
        {
            id: TransactionColumn.LOCK,
            options: {
                pin: "left",
            },
        },
        {
            id: TransactionColumn.DATE,
            options: {
                pin: "left",
            },
        },
        {
            id: TransactionColumn.SPLIT,
            options: {
                pin: "left",
            },
        },
        {
            id: TransactionColumn.BANK_DESCRIPTION,
        },
        {
            id: TransactionColumn.COUNTERPARTY,
        },
        ...middleColumns,
        {
            id: TransactionColumn.LEDGER,
        },
        {
            id: TransactionColumn.TRANSFER_MATCH,
        },
        {
            id: TransactionColumn.ACCOUNT,
        },
        {
            id: TransactionColumn.AMOUNT,
            options: {
                pin: "right",
            },
        },
        {
            id: TransactionColumn.REVIEW,
            options: {
                pin: "right",
            },
        },
        {
            id: TransactionColumn.ENTITY,
            options: {
                pin: "right",
            },
        },
    ];
}

interface CreateTransferReviewViewOptions {
    entityIds: number[];
    transferCategoryIds: string[];
}

export const createTransferReviewView = ({
    entityIds,
    transferCategoryIds,
}: CreateTransferReviewViewOptions): NamedView<TransactionView> => ({
    ...TRANSFER_REVIEW_BASE,
    columns: transferReviewColumns([
        {
            id: TransactionColumn.CATEGORY,
        },
    ]),
    filters: {
        entityIds,
        category: transferCategoryIds,
    },
});

interface CreateGlFirstTransferReviewViewOptions {
    entityIds: number[];
}

export const createGlFirstTransferReviewView = ({
    entityIds,
}: CreateGlFirstTransferReviewViewOptions): NamedView<TransactionView> => ({
    ...TRANSFER_REVIEW_BASE,
    columns: transferReviewColumns([]),
    filters: {
        entityIds,
        accountSubtypes: TRANSFER_REVIEW_ACCOUNT_SUBTYPES,
    },
});
